import { useEffect, useState } from 'react';
import type { Nullable } from 'corgi-types';

import type { MessageType } from 'common/enums/Alert';
import type { DispatchState } from 'common/types/React';

export type DrawerAlert = Nullable<{ message: string; type?: MessageType }>;

type useDrawerAlert = (isAlive?: boolean) => [DrawerAlert, DispatchState<DrawerAlert>];

export const useDrawerAlert: useDrawerAlert = (isAlive = false) => {
  const [alert, setAlert] = useState<DrawerAlert>(null);

  useEffect(() => () => setAlert(null), [isAlive]);

  return [alert, setAlert];
};
